import { IS_INTL } from '@/constants/global'
import type { Lang } from '@/typings/i18n'
import { isElectron } from '@/utils/common'
import { createI18n } from 'vue-i18n'
import de from './de'
import en from './en'
import fr from './fr'
import it from './it'
import ja from './ja'
import ko from './ko'
// import ar from './ar'
// import ru from './ru'
import zhCN from './zh-CN'
import zhHK from './zh-HK'

const getUserLanguage = async () => {
  if (!IS_INTL) {
    console.info('当前语言', 'zh-cn')
    return 'zh-cn'
  }

  const parsedUrl = new URL(location.href)
  const params = parsedUrl.searchParams
  const lang = params.get('lang') as Lang
  if (lang) {
    params.delete('lang')
    window.history.replaceState(null, '', parsedUrl.toString())
    return lang
  }

  const { useGlobalStore } = await import('@/stores/global')
  const globalStore = useGlobalStore()
  if (globalStore.language) {
    return globalStore.language
  }

  // const { region } = await import('@/apis/i18n')
  // const { scope } = await region()
  // if (scope === Scope.zh) {
  //   console.info('当前语言', 'zh-cn')
  //   return 'zh-cn'
  // }

  const language = navigator.language.toLowerCase()
  console.info('当前语言', language)
  if (language.includes('zh-cn') || language.includes('zh-hk') || language.includes('zh-tw')) {
    return 'zh-hant'
  } else if (language.includes('en')) {
    return 'en'
  } else if (language.includes('ja')) {
    return 'ja'
  } else if (language.includes('fr')) { // 法语
    return 'fr'
  } else if (language.includes('de')) { // 德语
    return 'de'
  } else if (language.includes('it')) { // 意大利语
    return 'it'
  } else if (language.includes('ko')) { // 韩语
    return 'ko'
  // } else if (language.includes('ar')) { // 阿拉伯语
  //   return 'ar'
  // } else if (language.includes('ru')) { // 俄语
  //   return 'ru'
  } else if (language.includes('zh-CN')) { // 简体中文
    return 'zh-cn'
  } else {
    return 'en' // 可以设置一个默认值
  }
}


const i18n = createI18n({
  legacy: false,
  // locale: getUserLanguage(),
  locale: 'en',
  fallbackLocale: 'en',
  messages: {
    'zh-cn': zhCN,
    'zh-hant': zhHK,
    en,
    ja,
    fr,
    de,
    it,
    ko,
    // ar,
    // ru,
  }
})

export async function setupI18n() {
  const { useGlobalStore } = await import('@/stores/global')
  const globalStore = useGlobalStore()
  i18n.global.locale.value = await getUserLanguage()
  globalStore.setLanguage(i18n.global.locale.value)
  console.info('设置语言', i18n.global.locale.value)
  if (isElectron()) {
    // @ts-ignore
    electronAPI.languageChange(i18n.global.locale.value)
  }
}

export default i18n